import { IDropdown } from '@app/shared/interfaces/dropdown';

export enum GENDER {
  'Female/woman' = 1,
  'Male/man' = 2,
  'Non-binary' = 3,
  'Gender non-conforming' = 4,
  'Transgender' = 5,
  'Not sure' = 6,
}

export const GENDER_DROPDOWN: IDropdown<string>[] = Object.values(GENDER)
  .filter((value) => isNaN(Number(value)) === true)
  .map((value) => ({ value: `${GENDER[value]}`, label: value } as IDropdown<string>));
